<form #searchForm (ngSubmit)="onSearch()" class="search-form-input" role="search" (focusout)="onFocusOut($event)">
    <label class="search-form-input__label" [class.open]="isSearchOpen" for="search" aria-label="'Search' | translate">
        <div class="search-form-input__wrapper">
            <input
                #searchInput
                [formControl]="queryField"
                autocomplete="off"
                class="search-form-input__input form-control"
                id="search"
                [placeholder]="'Search' | translate"
                [tabindex]="isSearchOpen ? 0 : -1"
                type="text" />
            <span class="search-form-input__icon">
                @if (customIcon && reflectToInnerIcon) {
                    <img [src]="customIcon" alt="Search" />
                } @else {
                    <core-icon name="icon-search" color="var(--icon-subtle)"></core-icon>
                }
            </span>
        </div>

        @if (showClearButton) {
            <button
                (click)="resetSearch()"
                aria-label="Clear search"
                class="btn-close btn--search-clear"
                type="button"></button>
        }

        <button
            type="button"
            class="search-form-input__close-mobile"
            (click)="closeSearch()"
            aria-label="Close search"
            [style.width]="getCloseButtonSize()"
            [style.height]="getCloseButtonSize()">
            @if (customCloseIcon) {
                <img
                    [src]="customCloseIcon"
                    class="custom-close-icon"
                    alt="Close"
                    [style.width]="getCloseButtonSize() ? '100%' : null"
                    [style.height]="getCloseButtonSize() ? '100%' : null" />
            } @else {
                <span
                    class="material-symbols-outlined close-icon close-icon__dark"
                    [style.font-size]="getCloseButtonSize()">
                    close
                </span>
            }
        </button>
    </label>

    <button coreButton type="submit" hidden [size]="'small'">Search</button>

    <button
        class="search-form-input__toggle"
        (click)="toggleSearch()"
        aria-label="Toggle search bar"
        [style.width]="isSearchOpen ? getCloseButtonSize() : null"
        [style.height]="isSearchOpen ? getCloseButtonSize() : null">
        @if (isSearchOpen) {
            @if (customCloseIcon) {
                <img
                    [src]="customCloseIcon"
                    class="custom-close-icon"
                    alt="Close"
                    [style.width]="getCloseButtonSize() ? '100%' : null"
                    [style.height]="getCloseButtonSize() ? '100%' : null" />
            } @else {
                <span class="material-symbols-outlined close-icon" [style.font-size]="getCloseButtonSize()">close</span>
            }
        } @else {
            @if (customIcon) {
                <img
                    class="custom-search-icon"
                    [class.close-icon__dark]="!isDarkModeEnabled"
                    [src]="customIcon"
                    alt="Search" />
            } @else {
                <span class="material-symbols-outlined search-icon">search</span>
            }
        }
    </button>
</form>
